import React, { FC, memo } from 'react';
import { OptionProps } from 'react-select';

// Define the data type for the option
interface CustomOptionData {
	value: string | number;
	label: string;
	itemIcon?: string; // Optional icon
	isSeparator?: boolean; // Optional separator flag
	styles?: { backgroundColor?: string; color?: string }; // ✅ Include styles
}

// Extend the props for the custom option
type CustomOptionProps = OptionProps<CustomOptionData, false>;

const CustomOption: FC<CustomOptionProps> = (props) => {
	const { data, innerRef, innerProps, isFocused, isSelected, selectProps  } = props;

	// Check if the Select component has isMulti = true
	const isMulti = selectProps.isMulti;

	// Apply styles conditionally
	const backgroundColor = isMulti
		? data.styles?.backgroundColor || 'white' // No selected/focused effect if isMulti = true
		: isSelected
		? data.styles?.backgroundColor || '#007bff'
		: isFocused
		? '#f8f9fa'
		: data.styles?.backgroundColor || 'white';

	const color = isMulti
		? data.styles?.color || '#212529' // Ensure default text color in multi-select mode
		: isSelected
		? data.styles?.color || 'white'
		: data.styles?.color || '#212529';

	return (
		<>
			{data.isSeparator && (
				<div
					style={{
						borderBottom: '1px solid #ddd',
						margin: '5px 0',
					}}
				/>
			)}
			<div
				ref={innerRef}
				{...innerProps}
				style={{
					display: 'flex',
					alignItems: 'center',
					padding: '10px',
					backgroundColor, // ✅ Use dynamic background color
					color, // ✅ Use dynamic text color
					cursor: 'pointer',
				}}>
				{data.itemIcon && (
					<div
						style={{
							marginRight: '10px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}>
						<i className={`fa-regular fa-${data.itemIcon}`}></i>
					</div>
				)}
				<div>{data.label}</div>
			</div>
		</>
	);
};

export default memo(CustomOption);
